import React from 'react';
import { useTranslation } from 'react-i18next';
import { Page, PageHeader } from '@tanium/react-page';
import { WelcomeBanner } from '@tanium/react-welcome-banner';
import { ManageAccountSection } from './ManageAccount/ManageAccountSection';
import { TenantDomainsProvider } from '../hooks/useTenantDomains';
import { IdpConfigsProvider } from '../hooks/useIdentityProviderConfigs';
import { DocLinks } from '../utilities/constants';

export const OverviewPage: React.VFC = () => {
  const { t } = useTranslation();

  return (
    <Page header={<PageHeader heading={''} />}>
      <WelcomeBanner
        header={t('Welcome to your Tanium Account')}
        summary={t('To learn more about how to use your Tanium Account, see the Tanium Account User Guide.')}
        userGuideLinkUrl={DocLinks.DOCS_HOME}
      />
      <IdpConfigsProvider>
        <TenantDomainsProvider>
          <ManageAccountSection />
        </TenantDomainsProvider>
      </IdpConfigsProvider>
    </Page>
  );
};
